import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'

import { getMarkers, type TMarkerSearchParams } from './get-markers'
import { getRooms, type TRoomSearchParams } from './get-rooms'
import {
  getSearchKeywords,
  type TSearchKeywordSearchParams,
} from './get-search-keywords'

export const mapQueries = {
  all: () => ['map'],
  markerLists: () => [...mapQueries.all(), 'marker'],
  markerList: (params: TMarkerSearchParams) =>
    queryOptions({
      queryKey: [...mapQueries.markerLists(), params],
      queryFn: () => getMarkers(params),
    }),
  roomLists: () => [...mapQueries.all(), 'room'],
  roomList: (params: TRoomSearchParams) =>
    infiniteQueryOptions({
      queryKey: [...mapQueries.roomLists(), params],
      queryFn: ({ pageParam }) => getRooms({ ...params, page: pageParam }),
      initialPageParam: 1,
      getNextPageParam: (lastPage, allPages, lastPageParam) => {
        if (lastPage.last) return undefined

        return lastPageParam + 1
      },
    }),
  searchKeywordLists: () => [...mapQueries.all(), 'search-keyword'],
  searchKeywordList: (params: TSearchKeywordSearchParams) =>
    queryOptions({
      queryKey: [...mapQueries.searchKeywordLists(), params],
      queryFn: () => getSearchKeywords(params),
    }),
}
